module.exports = __webpack_public_path__ + "static/media/Picture1.6d1e8e8b.png";